import { diContainer, serviceNames } from '../diContainer/diContainer';
import { RESTRICTION_ERRORS, CART } from '../constants/Errors';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';
import { NOTIFICATION_GROUP } from '../constants/Notifications';
import TransactionRepository from '../repositories/TransactionRepository';
import { shippingAPONotificationsList } from '../views/Notifications/ComponentNotificationFactory';

class EnhanceNotificationsCollectionUseCase {
  private notificationsCollection: NotificationsCollection;

  private transactionRepository: TransactionRepository;

  constructor() {
    this.notificationsCollection = diContainer.get(serviceNames.notificationsCollection);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
  }

  public execute = (): void => {
    if (this.notificationsCollection.hasNotification(RESTRICTION_ERRORS.SHIPPING_RESTRICTIONS_STATES)) {
      this.notificationsCollection.notifications.forEach(notification => {
        if (notification.key === RESTRICTION_ERRORS.SHIPPING_RESTRICTIONS_STATES
          && notification.group === NOTIFICATION_GROUP.SHIPPING) {
          const updatedNotification = { ...notification };
          updatedNotification.group = NOTIFICATION_GROUP.PAYMENT;
          this.notificationsCollection.addNotification(updatedNotification);
        }
      });
    }
    if (this.notificationsCollection.hasNotification(CART.TRANSACTIONS_LIMIT)) {
      const limitError = this.notificationsCollection.notifications.find(
        err => err.key === CART.TRANSACTIONS_LIMIT,
      );
      limitError.group = NOTIFICATION_GROUP.APP;
    }
    if (this.notificationsCollection.hasNotification(RESTRICTION_ERRORS.SHIPPING_UNAVAILABLE_FOR_ADDRESS)) {
      const restrictError = this.notificationsCollection.notifications.find(
        err => err.key === RESTRICTION_ERRORS.SHIPPING_UNAVAILABLE_FOR_ADDRESS,
      );
      restrictError.group = NOTIFICATION_GROUP.SHIPPING;
    }

    const apoNotifications = this.notificationsCollection.getNotifications(shippingAPONotificationsList);

    if (apoNotifications.length > 0 ) {
      const products = this.transactionRepository.transaction.cart.hazmatItemNames || [];

      apoNotifications.forEach(apoNotification => {
        apoNotification.data = {
          data: { products },
        };
      });
    }
  };
}

export default EnhanceNotificationsCollectionUseCase;
